export default __webpack_public_path__ + "static/media/15_pci_proxy.116ed78a.svg";